import { get } from "services/AXIOS";
import { LANDING_PAGE_STATS } from "./CONSTANTS";

// Fetch landing page stats
export const fetchLandingPageStats = async () => {
    try {
      return get(LANDING_PAGE_STATS);
    } catch (error) {
      console.error("Error fetching landing page stats:", error);
    }
};